import { lazyLoad } from 'utils/loadable';

export const EnableAuthenticator = lazyLoad(
  () => import('./enableAuthenticator.page'),
  (module) => module.EnableAuthenticator
);
